import { createContext } from 'react';

export const CartStoreContext = createContext({});
